import React from "react";
import { useFaildReports, useReports } from "../../projectManagementQueries";
import { LSDBCoreTable } from "../../../common/LSDBCoreTable";
import { Button, FormControl, FormLabel, Grid, Icon, IconButton, LinearProgress, Paper, Radio, RadioGroup, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@material-ui/core";
import { ErrorMessage } from "../../../common/ErrorMessage";
import { generalFilter } from "../../../../util/filter";
import { useHistory, useParams } from "react-router";
import { TravelerModal } from "../../../common/travelerModal";
import { useFetchContext } from "../../../common/FetchContext";
import { urls } from "../../../common/urls";
import moment from "moment";
import { toast } from "react-toastify";
import Chip from "@material-ui/core/Chip";
import CallSplitIcon from "@material-ui/icons/CallSplit";
import { ThreadedViewerReport } from "./threadedViewerReport";
import { renderHeader } from "../../../common/util";
import {
  useDownloadProjects,
  useDownloadableProjects,
} from "../../projectQueries";

import {
  useTable,
  useSortBy,
  HeaderProps,
  useFilters,
  useRowSelect,
  useGlobalFilter,
  Row,
  usePagination,
  defaultColumn,
} from "react-table";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Alert, AlertTitle } from "@material-ui/lab";
import MuiTable from "@material-ui/core/Table";
import Container from "@material-ui/core/Container";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { useLocations } from "../../../intake/intakeQueries";
import { useQueryClient } from "react-query";
import { getTheme } from "../../../common/getLocalTheme";
import { PassedReportTable } from "./PassedReportTable";

const dateFormatter = (dateToFormat: Date) => {
  return dateToFormat.toDateString();
};

const Reports = () => {

  const [startDate, setStartDate] = React.useState('');
  const [endDate, setEndDate] = React.useState('');
  const [selectedRows, setSelectedRows] = React.useState('');
  const [filterType, setFilterType] = React.useState("0");

  const [selected, setSelected] = React.useState<number[]>([]);
  const [reports, setReports] = React.useState<any>(null);



  const {
    mutateAsync: mutateGetFlashReports,
    data: dataReports,
    error: reportsError,
    isLoading: isLoadingReports,
    isError: isErrorReports,
  } = useFaildReports();

  React.useEffect(() => {
    if (dataReports) {
      setReports(dataReports);
    }
  }, [dataReports]);

  const { authAxios } = useFetchContext();
  const getDownloads = async (): Promise<any> => {
    try {

      if (!startDate || !endDate) {
        toast.warning("Please select start and end date");
        return;
      }

      let finalSelectedRows = selectedRows;

      // ✅ If Mechanical Load selected
      if (filterType === "1" && reports?.other_results?.length > 0) {
        const allIds = reports.other_results.map((item: any) => item.id);
        finalSelectedRows = allIds.join(",");

        setSelectedRows(finalSelectedRows); // store in state (optional)
      }

      const response = await authAxios.get(
        urls.actionResults.faild_report_download(
          startDate,
          endDate,
          filterType,
          finalSelectedRows
        ),
        {
          responseType: "blob",
        }
      );

      const downloadUrl = URL.createObjectURL(response.data);
      let a = document.createElement("a");
      a.href = downloadUrl;
      a.download = `${moment().format("MMM-DD-YYYY-HHmmss")}`;
      document.body.appendChild(a);
      a.click();

    } catch (error) {
      console.log(error);
      toast.warning("Download Error");
    }
  };

  const handleStartDateChange = (e: { target: { value: React.SetStateAction<string>; }; }) => {

    console.log(e)
    setStartDate(e.target.value);
  };


  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setFilterType(value);

    setReports("");
    setStartDate("");
    setEndDate("");
    setSelected([]);
    setSelectedRows("");
  };


  const handleSelectedRowsChange = (selectedData: any[]) => {

    const procedure_id = selectedData
      .map((row: any) => row.id);

    if (procedure_id.length === 1) {
      setSelectedRows(procedure_id[0]);
    } else if (procedure_id.length > 1) {
      setSelectedRows(procedure_id.join(","));
    }
    // console.log("Selected Rows:", selectedData);

    // setSelectedRows(selectedData);
  };

  const handleEndDateChange = (e: { target: { value: React.SetStateAction<string>; }; }) => {
    setEndDate(e.target.value);
  };


  const searchData = async () => {

    if (!filterType) {
      toast.warning("Please select Filter Type");
      return;
    }

    if (!startDate || !endDate) {
      toast.warning("Please select start and end date");
      return;
    }

    try {
      await mutateGetFlashReports({
        authAxios,
        startDate,
        endDate,
        filterType,
        tsd_ids: selected.join(",")
      });

    } catch (error) {
      toast.error("Error fetching reports");
    }


  };



  const [noteID, setNoteID] = React.useState(
    Number((useParams() as { note_id: string }).note_id)
  );
  const [open, setOpen] = React.useState(noteID ? true : false);



  const columns = React.useMemo(
    () => [

      {
        Header: "ID",
        accessor: "id",
        filter: generalFilter,
      },
      {
        id: "Serial Number",
        Header: "Serial Number",
        accessor: "unit_serial_number",
        minWidth: 220,
        width: 250,
        Cell: ({ cell }: any) => {
          return <TravelerModal serialNumber={cell.value} />;
        },
      },
      {
        id: "Work Order",
        Header: "Work Order",
        accessor: "work_order_name",
        minWidth: 220,
        width: 250,
        filter: generalFilter,
      },
      {
        id: "Project Number",
        Header: "Project Number",
        accessor: "project_number",
        minWidth: 220,
        width: 250,
        filter: generalFilter,
      },
      {
        id: "Linear Execution Group",
        Header: "Linear Execution Group",
        accessor: "linear_execution_group",
        minWidth: 250,
        width: 250,
        filter: generalFilter,
        Cell: ({ cell }: any) => (
          <Typography>
            {cell.value ? cell.value : "N/A"}
          </Typography>
        ),
      },
      {
        id: "Execution Group Name",
        Header: "Execution Group Name",
        accessor: "name",
        minWidth: 250,
        width: 250,
        filter: generalFilter,
      },

      {
        id: "Procedure Definition Name",
        Header: "Procedure Definition Name",
        accessor: "procedure_definition_name",
        minWidth: 250,
        width: 250,
        filter: generalFilter,
      },
      {
        id: "Date",
        Header: "Date",
        accessor: "start_datetime",
        minWidth: 250,
        width: 250,
        Cell: ({ cell }: any) => {
          return cell.value !== null ? (
            <p>{dateFormatter(new Date(cell.value))}</p>
          ) : (
            <p>N/A</p>
          );
        },
        filter: generalFilter,
      },
      {
        id: "Disposition",
        Header: "Disposition",
        accessor: "disposition_name",
        minWidth: 220,
        width: 250,
        filter: generalFilter,
        Cell: ({ cell }: any) => (
          <Typography
            style={{
              color:
                cell.value?.toLowerCase() === "pass" ||
                  cell.value?.toLowerCase() === "completed"
                  ? "green"
                  : "inherit",
            }}
          >
            {cell.value || "N/A"}
          </Typography>
        ),
      },
      {
        id: "Defect Name",
        Header: "Defect Name",
        accessor: "defect_name",
        minWidth: 220,
        width: 250,
        filter: generalFilter,
        Cell: ({ cell }: any) => (
          <Typography>
            {cell.value ? cell.value : "N/A"}
          </Typography>
        ),
      },
      {
        id: "Test Defiinition Name",
        Header: "Test Defiinition Name",
        accessor: "test_sequence_definition_name",
        minWidth: 220,
        width: 250,
        filter: generalFilter,
      },
      {
        id: "Asset Name",
        Header: "Asset Name",
        accessor: "asset_name",
        minWidth: 220,
        width: 250,
        filter: generalFilter,
      },
      {
        id: "Flag",
        Header: "Flag",
        accessor: "notes[0].subject",
        minWidth: 220,
        width: 250,

        Cell: ({ row }: any) => (
          // <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
          //   <label>{cell.value}</label>
          //   <IconButton
          //     onClick={() => {
          //       setNoteID(cell.value);
          //       setOpen(true);
          //     }}
          //   >
          //     <Icon>visibility</Icon>
          //   </IconButton>
          // </div>


          <Button
            fullWidth
            color="primary"
            onClick={() => {
              setNoteID(row.values.note_id);
              setOpen(true);
            }}
          >
            {row.values.Flag}
          </Button>
        ),

      },

      {
        Header: "note_id",
        accessor: "note_id",
        filter: generalFilter,
      },

    ],
    []
  );

  if (isLoadingReports) {
    return <LinearProgress />;
  }

  if (isErrorReports) {
    return <ErrorMessage error={reportsError} />;
  }



  return (
    <>
      <Grid
        container
        direction="row"
        alignItems="center"
        spacing={0}>



        <Grid item xs={12}>
          <FormControl >
            <FormLabel style={{ color: "primary" }}>Filter By</FormLabel>

            <RadioGroup
              row
              value={filterType}
              onChange={handleFilterChange}
            >
              <FormControlLabel
                value="0"
                control={<Radio color="primary" />}
                label="All"
                style={{ color: "inherit" }}
              />

              <FormControlLabel
                value="1"
                control={<Radio color="primary" />}
                label="Mechanical Load"
                style={{ color: "inherit" }}
              />
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid item xs={6} container justifyContent="flex-start" alignItems="center" spacing={2} style={{ marginTop: '10px', marginBottom: '10px' }}>
          <Grid item >
            <TextField
              id="start-date"
              label="Start Date"
              type="date"
              value={startDate}
              onChange={handleStartDateChange}
              InputLabelProps={{
                shrink: true, // Keeps the label visible when a value is selected
              }}
              variant="outlined" // Adds an outline to the input
            />
          </Grid>

          <Grid item >
            <TextField
              id="end-date"
              label="End Date"
              type="date"
              value={endDate}
              onChange={handleEndDateChange}
              InputLabelProps={{
                shrink: true, // Keeps the label visible when a value is selected
              }}
              variant="outlined" // Adds an outline to the input
            />
          </Grid>

          <Grid item>
            <Button
              variant="outlined" // Outlined button
              color="primary"
              onClick={searchData}
            >
              SEARCH
            </Button>
          </Grid>

          {reports && (
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={getDownloads}
                disabled={
                  (!reports?.other_results?.length || reports.other_results.length === 0) &&
                  (!reports?.pass_reports?.length || reports.pass_reports.length === 0)
                }
              >
                Download
              </Button>
            </Grid>
          )}

        </Grid>

      </Grid>
      <div>



        <Paper style={{ padding: 15, marginTop: 20 }}>
          <div
            style={{ display: "flex", flexWrap: "wrap", gap: 12 }} >
            {reports?.tsd_data?.map((item: any) => (
              <Chip key={item.id}
                label={item.tsd_name}
                clickable color={selected.includes(item.id) ? "primary" : "default"}
                onClick={() => { setSelected(prev => prev.includes(item.id) ? prev.filter(id => id !== item.id) : [...prev, item.id]); }}
                style={{ borderRadius: 10, height: 36 }} />))}
          </div>
        </Paper>




        {reports && (
          <>
            {reports?.other_results?.length > 0 ? (
              <>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: 30,
                    marginBottom: 30,
                  }}
                >
                  <Typography variant="h3">
                    Failed Reports
                  </Typography>

                  <Typography variant="h6" style={{ marginLeft: 80 }}>
                    Total Failed Reports: {reports?.other_results?.length}
                  </Typography>
                </div>
              </>
            ) : (
              <Paper
                elevation={2}
                style={{
                  marginTop: 30,
                  marginBottom: 30,
                  padding: 30,
                  textAlign: "center",
                }}
              >
                <Typography variant="h6" color="textSecondary">
                  No Failed Data Found
                </Typography>
              </Paper>
            )}
          </>
        )}

        {reports?.other_results?.length > 0 && (
          <LSDBCoreTable
            columns={columns}
            data={reports.other_results}
            hiddenColumns={["id", "note_id"]}
            getCellProps={(cellInfo: any) => {
              if (cellInfo.column.Header === "ETA Datetime") {
                const originalInfo = cellInfo.row.original;
                const etaDatetime = new Date(originalInfo.eta_datetime);
                const today = new Date();
                const dayDiff = Math.floor(
                  (Date.UTC(
                    etaDatetime.getFullYear(),
                    etaDatetime.getMonth(),
                    etaDatetime.getDate()
                  ) -
                    Date.UTC(
                      today.getFullYear(),
                      today.getMonth(),
                      today.getDate()
                    )) /
                  (1000 * 60 * 60 * 24)
                );

                return {
                  style: {
                    backgroundColor:
                      dayDiff <= 0 ? "red" : dayDiff === 1 ? "yellow" : "green",
                    fontWeight: "bold",
                    color: dayDiff === 1 ? "black " : "white",
                  },
                };
              }
              if (cellInfo.column.Header === "Ready to process?") {
                if (!cellInfo.value) return {};
                return { style: { backgroundColor: "green" } };
              }

              return {};
            }}
          />

        )}



      </div>



      {reports && filterType === "0" && (
        <>
          {reports?.pass_reports?.length > 0 ? (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: 30,
                  marginBottom: 30,
                }}
              >
                <Typography variant="h3">
                  Pass Reports
                </Typography>

                <Typography variant="h6" style={{ marginLeft: 80 }}>
                  Total Pass Reports: {reports?.pass_reports?.length}
                </Typography>
              </div>

              <PassedReportTable
                passedData={reports.pass_reports}
                onSelectedRowsChange={handleSelectedRowsChange}
              />
            </>
          ) : (
            <Paper
              elevation={2}
              style={{
                marginTop: 30,
                marginBottom: 30,
                padding: 30,
                textAlign: "center",
              }}
            >
              <Typography variant="h6" color="textSecondary">
                No Pass Data Found
              </Typography>
            </Paper>
          )}
        </>
      )}





      <ThreadedViewerReport id={noteID} open={open} setOpen={setOpen} />
    </>
  );
};

export default Reports;
